<template>
  <div class="jojo_product">
       <div class="main_content" :style="'height:' + allPageHeight + 'px;width:' + currWidth + 'px'">
         <div>
           <iframe src="https://mobile.worldkey.com/"> </iframe>
         </div>
       </div>
       <!-- <div class="code_class" :style="'margin-left:' + mrleft + 'px'">
           <div @mousemove="showImg" @mouseleave="closeImg">Start on Mobile</div>
           <div class="code_img" v-if="isShow"><img src="../assets/www.jojoworld.com@2x.png"/></div>
       </div> -->
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
      allPageHeight: 0,
      currWidth: 0,
      mrleft: 0,
      isShow: false
    }
  },
  created () {
    let height = document.body.clientHeight - 80
    this.allPageHeight = height
    if ((height / (800 / 390)) < 350) {
      this.currWidth = 350
    } else {
      this.currWidth = (height / (800 / 390))
    }
    this.mrleft = this.currWidth / 2 + 50
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  components: {
  },
  methods: {
    showImg () {
      this.isShow = true
    },
    closeImg () {
      this.isShow = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.jojo_product {
  position:relative;
  width:100%;
  iframe {
    width:100%;
    height:100%;
    border:none;
    font-size:14px !important;
    background:#000000;
  }
  .main_content {
      height:100%;
      margin:0 auto;
      border:5px solid #28FFF2;
      border-radius: 20px;
      overflow: hidden;
    >div {
       height:calc(~"100%");
    }
  }
  .code_class {
    position:absolute;
    top:70px;
    left:50%;
    width:150px;
    >div:nth-child(1) {
      width:100%;
      height:40px;
      border-radius: 21px;
      background:#282828;
      text-align: center;
      line-height: 40px;
      margin-bottom:9px;
      cursor: pointer;
    }
    >div:nth-child(2) {
      text-align: center;
      img {
        width:122px;
        height:122px;

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Product.vue